<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Born in Brussels. Graduated in medicine from Brussels Free<br/>
University in 1952.</p><br/>
<p style="text-align: center;">Internship in medicine in Brussels 1952–1956</p><br/>
<p style="text-align: center;">Training in internal medicine at Memorial Hospital, Cornell Medical School 1956–1960</p><br/>
<p style="text-align: center;">Training in epidemiology, at Memorial Hospital, Cornell Medical School, 1960–1961</p><br/>
<p style="text-align: center;">Master’s degree in hygiene, Harvard School of Public Health, 1961–1962</p><br/>
<p style="text-align: center;">Assistant professor in epidemiology, Faculty of Médicine, Brussels Free University, 1962–1964</p><br/>
<p style="text-align: center;">European Commission official, 1964–1985</p><br/>
<p style="text-align: center;">Invited professor, Rome University La Sapienza, 1988–1990</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0d9eba79